import React, { useState } from 'react';
import { Alert } from '@biome-design-system/ui/Alert';
import { buildMarkdownParser } from 'Src/utils/buildMarkdownParser';
import { useAnchorClickListener } from 'Src/utils/hooks';
import { Log } from 'Src/types';
import { AlertMarkdownContainer } from './styles';

interface EmergencyDisclaimerMarkdownProps {
  bannerConfig: {
    markdown?: string[];
    enabled?: boolean;
  };
  closeButtonAriaLabel: string;
  log: Log;
}

export const EmergencyDisclaimerMarkdown = ({
  bannerConfig,
  closeButtonAriaLabel,
  log
}: EmergencyDisclaimerMarkdownProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const bannerNodeId = 'emergency-banner-md';
  useAnchorClickListener(`#${bannerNodeId}`, (href: string) => {
    log('user_action.search_results.emergency_warning.warning_link', { href });
  });

  if (!isOpen) {
    return null;
  }
  const { markdown = [] } = bannerConfig;
  const handleClose = () => {
    log('user_action.search_results.emergency_warning.close_warning');
    setIsOpen(false);
  };

  const markdownParser = buildMarkdownParser();

  return (
    <div id={bannerNodeId}>
      <Alert
        onClose={handleClose}
        severity="error"
        variant="outlined"
        closeText={closeButtonAriaLabel}
      >
        <AlertMarkdownContainer
          dangerouslySetInnerHTML={{
            __html: markdownParser.render(markdown.join('\n'))
          }}
        />
      </Alert>
    </div>
  );
};
